import { Component } from '@angular/core';

@Component({
  selector: 'tt-about-view',
  templateUrl: './about-view.component.html',
  styleUrls: ['./about-view.component.css']
})
export class AboutViewComponent {

}
